export enum AnimalEventStatus {
  COMPLETE = '1',
  FAILED = '2',
  PLANNED = '3',
}
